<script>
import {ElNotification} from "element-plus";

export default {
  name: "QuarterReport",
  data() {
    return {
      loading: false,
      fin_year: new Date().getFullYear(),
    }
  },
  computed: {
    years() {
      let currentYear = new Date().getFullYear();
      let years = [];
      for (let i = 2024; i <= currentYear; i++) {
        years.push(i);
      }
      return years
    }
  },
  methods: {
    downloadExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/quarter-payments/excel?fin_year=${this.fin_year}`, {
            responseType: "blob"
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  }
}
</script>

<template>
  <div>
    <div class="header">
      <el-select size="large" id="year" placeholder="Yil" v-model="fin_year" style="max-width:120px; margin-right: 15px">
        <el-option v-for="y in years" :key="y" :value="y" :label="y"/>
      </el-select>
      <el-button size="large" v-loading="loading" :disabled="loading" class="upload-demo" type="success" @click="downloadExcel">
        <img
            style="margin-right: 10px"
            alt=""
            src="@/assets/images/icons/download.svg"
        />
        Excel yuklab olish
      </el-button>
    </div>
  </div>
</template>

<style scoped>

</style>
